import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faHome, faImage, faFileAlt, faCog, faSave, faUpload,
  faTrashAlt, faPlus, faTimes, faCheckCircle, faExclamationTriangle,
  faSpinner, faEdit, faEye, faEyeSlash, faCalendarAlt,
  faStar, faMapMarkerAlt, faBullhorn, faInfoCircle, faStore,
  faTicketAlt, faPhone, faEnvelope, faGlobe, faBars,
  faPalette, faSlidersH, faCode, faDatabase, faUsers,
  faChartBar, faWallet, faShoppingCart, faClock, faArrowLeft,
  faUtensils, faMusic, faBuilding, faUser, faQuoteLeft,
  faMapPin, faLink, faCopy, faSyncAlt, faTrash
} from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import './WebPageEditor.css';

//const API_BASE_URL = 'http://localhost/royaleheritagefiesta/api';
const API_BASE_URL = 'https://royaleheritagefiesta.com/royaleheritagefiesta/api';
const WebPageEditor = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [activePage, setActivePage] = useState('home');
  const [activeTab, setActiveTab] = useState('content');
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [uploadingImage, setUploadingImage] = useState(null);
  const [allImages, setAllImages] = useState([]);

  // ========== HOME PAGE CONTENT ==========
  const [homeContent, setHomeContent] = useState({
    hero: {
      enabled: true,
      title: 'Royal Heritage Fiesta',
      subtitle: 'Where Legacy Meets Celebration',
      description: 'Experience timeless elegance and grandeur like never before. Join us for unforgettable royal celebrations.',
      buttonText: 'Explore Events',
      phone: '+91 93965 36350',
      backgroundImage: ''
    },
    carousel: {
      enabled: true,
      slides: [
        { id: 1, title: 'Royal Heritage Fiesta', description: 'Where Legacy Meets Celebration', link: '/RoyalHeritageFiesta', image: '' },
        { id: 2, title: 'Royal Dinners', description: 'Indulge in exquisite culinary masterpieces', link: '/RoyalDinners', image: '' },
        { id: 3, title: 'Music & Concerts', description: 'World-class performances', link: '/MusicAndConcerts', image: '' }
      ],
      autoPlay: true,
      interval: 5000
    },
    floatingImages: {
      enabled: true,
      images: [
        { id: 1, url: '', alt: 'Special Offer 1', link: '' },
        { id: 2, url: '', alt: 'Special Offer 2', link: '' }
      ],
      autoRotate: true,
      rotateInterval: 5000
    },
    featuredEvent: {
      enabled: true,
      badge: 'FEATURED EVENT',
      button1: 'Book a Stall',
      button2: 'Get Tickets',
      backgroundImage: ''
    },
    upcomingEvents: {
      enabled: true,
      title: 'Featured Events',
      subtitle: '✦ UPCOMING EVENTS',
      viewAllText: 'View all',
      maxEvents: 4
    },
    services: {
      enabled: true,
      title: 'Our Signature Experiences',
      subtitle: 'Discover the essence of royal celebrations',
      items: [
        { id: 1, title: 'Royal Heritage Fiesta', description: 'Curated heritage experiences celebrating tradition and grandeur.', link: '/RoyalHeritageFiesta', icon: 'globe', image: '' },
        { id: 2, title: 'Royal Dinners', description: 'Exquisite fine dining experiences with royal ambiance and culinary mastery.', link: '/RoyalDinners', icon: 'utensils', image: '' },
        { id: 3, title: 'Music & Concerts', description: 'World-class performances and unforgettable musical experiences.', link: '/MusicAndConcerts', icon: 'music', image: '' }
      ]
    },
    booking: {
      enabled: true,
      title: 'Plan Your Royal Experience',
      subtitle: 'Share your details and we\'ll get back to you via WhatsApp',
      whatsapp_number: '919966252374',
      button_text: 'Send via WhatsApp',
      formFields: [
        { name: 'customerName', label: 'Full Name', type: 'text', required: true },
        { name: 'email', label: 'Email Address', type: 'email', required: true },
        { name: 'phoneNumber', label: 'Phone Number', type: 'tel', required: true },
        { name: 'eventType', label: 'Event Type', type: 'select', required: true, options: ['Royal Heritage Fiesta', 'Royal Dinners', 'Music & Concerts'] },
        { name: 'attendees', label: 'Expected Guests', type: 'number', required: false },
        { name: 'preferredDate', label: 'Preferred Date', type: 'date', required: false },
        { name: 'requirements', label: 'Special Requirements', type: 'textarea', required: false }
      ]
    },
    about: {
      enabled: true,
      title: 'About Royal Heritage Fiesta',
      description: 'Royal Heritage Fiesta is dedicated to creating unforgettable experiences that blend tradition with modern elegance. From majestic royal dinners to spectacular concerts, we bring your vision to life with impeccable attention to detail and timeless sophistication.',
      image: ''
    },
    testimonials: {
      enabled: true,
      title: 'What Our Guests Say',
      subtitle: 'Experiences that speak for themselves',
      items: [
        { id: 1, name: 'Vikram Singh', title: 'Event Attendee', text: 'The Royal Heritage Fiesta was absolutely magnificent! Every detail was perfect.', image: '' },
        { id: 2, name: 'Meera Kapoor', title: 'Dinner Guest', text: 'The Royal Dinners experience was beyond imagination. Truly world-class hospitality.', image: '' },
        { id: 3, name: 'Arjun Nair', title: 'Music Lover', text: 'The concert was spectacular! Perfect acoustics and unforgettable performances.', image: '' }
      ]
    },
    location: {
      enabled: true,
      title: 'Our Venues',
      subtitle: 'Experience royalty at our premier locations',
      hq_name: 'Hyderabad (HQ)',
      hq_address: 'VIP Hills, Silicon Valley, Madhapur',
      hq_city: 'Hyderabad - 500081, Telangana',
      hq_phone: '+91 99662 52374',
      hq_email: 'royaleheritagefiesta@gmail.com',
      map_embed: 'https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d7612.584996745508!2d78.38633559192071!3d17.445708893577407!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sin!4v1774850334297!5m2!1sen!2sin',
      additionalVenues: []
    },
    cta: {
      enabled: true,
      title: 'Ready To Experience Royalty?',
      subtitle: 'Book your seat at our next grand celebration',
      button1_text: 'Talk to us',
      button2_text: 'Call +91 99662 52374',
      phone1: '+919396536350',
      phone2: '+919966252374'
    },
    seo: {
      metaTitle: 'Royal Heritage Fiesta - Experience Royalty',
      metaDescription: 'Experience timeless elegance and grandeur at Royal Heritage Fiesta. Book stalls, get tickets for royal dinners and concerts.',
      metaKeywords: 'royal heritage, fiesta, events, concerts, royal dinners',
      ogImage: ''
    },
    colors: {
      primary: '#b8860b',
      secondary: '#1a1a2e',
      background: '#f5f5f5',
      textDark: '#333333',
      textLight: '#ffffff',
      accent: '#dc3545'
    }
  });

  // ========== SERVICES PAGE CONTENT ==========
  const [servicesContent, setServicesContent] = useState({
    hero: { title: 'Our Royal Services', subtitle: 'Experience the epitome of elegance with our signature royal experiences', button_text: 'Plan Your Royal Event', backgroundImage: '' },
    services_section: { title: 'Our Premier Services', subtitle: 'Exquisite offerings that define royal elegance' },
    service1: { title: 'Royal Heritage Festia', description: 'Curated heritage experiences celebrating tradition and grandeur with royal elegance.', image: '', path: '/RoyalHeritageFiesta', features: ['Heritage Walks', 'Royal Processions', 'Cultural Performances', 'Traditional Cuisine'] },
    service2: { title: 'Royal Dinners', description: 'Exquisite fine dining experiences with royal ambiance and culinary mastery.', image: '', path: '/RoyalDinners', features: ['Michelin-Star Chefs', 'Royal Table Settings', 'Live Music', 'Premium Wine Selection'] },
    service3: { title: 'Music & Concerts', description: 'World-class performances and unforgettable musical experiences that move your soul.', image: '', path: '/MusicAndConcerts', features: ['International Artists', 'Live Orchestras', 'Acoustic Sessions', 'Sound Engineering'] },
    why_choose_us: { title: 'The Royal Heritage Advantage', subtitle: 'What makes us the premier choice for royal celebrations' },
    why_items: [
      { icon: 'bi-globe2', title: '10+ Years Excellence', description: 'Over a decade of crafting royal experiences' },
      { icon: 'bi-star', title: '500+ Royal Events', description: 'Proven track record of successful celebrations' },
      { icon: 'bi-people', title: 'Expert Team', description: 'Dedicated specialists in luxury events' },
      { icon: 'bi-globe2', title: 'Global Reach', description: 'Events across 20+ countries' }
    ],
    supporting_services: { title: 'Supporting Services', subtitle: 'Complete solutions for your royal celebration' },
    support_items: [
      { icon: 'bi-calendar-check', title: 'Event Planning', description: 'Comprehensive planning and coordination.' },
      { icon: 'bi-brush', title: 'Royal Decor', description: 'Opulent decorations reflecting royal heritage.' },
      { icon: 'bi-people', title: 'VIP Hospitality', description: 'Premium hospitality for distinguished guests.' },
      { icon: 'bi-camera-reels', title: 'Photography & Video', description: 'Professional media coverage.' },
      { icon: 'bi-shield-check', title: 'Security Services', description: 'Comprehensive security arrangements.' },
      { icon: 'bi-gem', title: 'Custom Experiences', description: 'Tailored experiences for your vision.' }
    ],
    our_process: { title: 'Our Royal Process', subtitle: 'A meticulous approach to crafting unforgettable experiences' },
    process_items: [
      { num: '01', icon: 'bi-star', title: 'Royal Consultation', desc: 'Understand your vision' },
      { num: '02', icon: 'bi-brush', title: 'Curated Planning', desc: 'Design bespoke experience' },
      { num: '03', icon: 'bi-play-circle', title: 'Royal Execution', desc: 'Flawless delivery' },
      { num: '04', icon: 'bi-star', title: 'Memorable Moments', desc: 'Creating lasting impressions' },
      { num: '05', icon: 'bi-heart', title: 'Royal Follow-up', desc: 'Ensuring satisfaction' }
    ],
    testimonials: { title: 'What Our Guests Say', subtitle: 'Experiences that speak for themselves' },
    testimonial_items: [
      { text: "The Royal Heritage Festia was absolutely magnificent! Every detail was perfect.", name: "Vikram Singh", title: "Event Attendee", img: "", rating: 5 },
      { text: "The Royal Dinners experience was beyond imagination. Truly world-class hospitality.", name: "Meera Kapoor", title: "Dinner Guest", img: "", rating: 5 },
      { text: "The concert was spectacular! Perfect acoustics and unforgettable performances.", name: "Arjun Nair", title: "Music Lover", img: "", rating: 5 }
    ],
    faq: { title: 'Frequently Asked Questions', subtitle: 'Quick answers about our royal services' },
    faq_items: [
      { question: "What is included in the Royal Heritage Festia experience?", answer: "Royal Heritage Festia includes curated heritage walks, royal processions, cultural performances, traditional cuisine, and immersive experiences." },
      { question: "How far in advance should I book a Royal Dinner?", answer: "We recommend booking Royal Dinners 3-6 months in advance." },
      { question: "Do you handle international artists for Music & Concerts?", answer: "Yes! We have partnerships with world-class international artists." },
      { question: "Can I customize the Royal Dinners menu?", answer: "Absolutely! Our culinary team works closely with you." }
    ],
    booking: { title: "Let's Create Your Royal Experience", subtitle: "Share your vision and we'll bring it to life", whatsapp_number: "919966252374", button_text: "Send Enquiry via WhatsApp" }
  });

  // ========== ABOUT US PAGE CONTENT ==========
  const [aboutContent, setAboutContent] = useState({
    hero: { title: 'Crafting Royal Experiences', subtitle: 'Where legacy meets celebration — creating unforgettable moments of timeless elegance and grandeur', badge: '✦ SINCE 2015', backgroundImage: '' },
    story: { title: 'Where Royalty Meets Celebration', lead: 'Creating unforgettable experiences that blend tradition with modern elegance since 2015', description1: 'Royal Heritage Festia was born from a vision to bring the grandeur of royal celebrations to modern events.', description2: 'Today, we create extraordinary experiences across the globe, from intimate royal dinners to spectacular concerts.', stats: [{ number: '500+', label: 'Royal Events' }, { number: '50+', label: 'Global Partners' }, { number: '98%', label: 'Client Satisfaction' }], image: '' },
    mission: { title: 'Our Mission', description: 'To create unforgettable royal experiences that celebrate heritage, culture, and timeless elegance.', list: ['Deliver royal excellence', 'Create lasting memories', 'Honor traditions', 'Exceed expectations'] },
    vision: { title: 'Our Vision', description: 'To be India\'s most prestigious luxury event management company.', list: ['Global recognition', 'Cultural preservation', 'Innovation in elegance', 'Timeless experiences'] },
    values: { title: 'Our Royal Values', subtitle: 'The principles that guide every celebration we create', items: [
      { icon: 'bi-globe', title: 'Royal Excellence', desc: 'We deliver nothing but the finest experiences.' },
      { icon: 'bi-gem', title: 'Timeless Elegance', desc: 'Creating experiences that blend tradition with modern sophistication.' },
      { icon: 'bi-people', title: 'Personalized Service', desc: 'Tailored experiences that reflect your unique vision.' },
      { icon: 'bi-star', title: 'Unforgettable Moments', desc: 'Crafting memories that last a lifetime.' },
      { icon: 'bi-shield-check', title: 'Trust & Integrity', desc: 'Building lasting relationships through honesty.' },
      { icon: 'bi-globe', title: 'Global Standards', desc: 'Bringing world-class excellence to every celebration.' }
    ] },
    team: { title: 'Meet Our Royal Team', subtitle: 'The visionaries behind your celebrations', members: [
      { name: 'Rajesh Singh', position: 'Founder & Creative Director', description: 'With over 15 years of experience in luxury events.', image: '' },
      { name: 'Priya Reddy', position: 'Head of Royal Experiences', description: 'Expertise in curating bespoke experiences.', image: '' }
    ] },
    cta: { title: 'Ready to Experience Royalty?', subtitle: 'Let\'s create your unforgettable celebration together', button1_text: 'Plan Your Event', button2_text: 'Call Us', phone: '+919966252374' }
  });

  // ========== CONTACT US PAGE CONTENT ==========
  const [contactContent, setContactContent] = useState({
    hero: { title: 'Let\'s Create Something Royal', subtitle: 'Your vision deserves royal execution. Reach out to our team of experts.', badge: '✦ CONNECT WITH US', backgroundImage: '' },
    contact_cards: [
      { icon: 'bi-telephone-fill', title: 'Call Us', subtitle: 'Available 24/7', contact: '+91 99662 52374', link_type: 'tel', action: 'Call Now' },
      { icon: 'bi-envelope-fill', title: 'Email Us', subtitle: '24hr Response', contact: 'royaleheritagefietsa@gmail.com', link_type: 'email', action: 'Send Email' },
      { icon: 'bi-whatsapp', title: 'WhatsApp', subtitle: 'Instant Chat', contact: '+91 99662 52374', link_type: 'whatsapp', action: 'Start Chat' }
    ],
    stats: [
      { icon: 'bi-globe2', number: '500+', label: 'Royal Events' },
      { icon: 'bi-clock-history', number: '24/7', label: 'Royal Support' },
      { icon: 'bi-hourglass-split', number: '<2hr', label: 'Response Time' },
      { icon: 'bi-star-fill', number: '98%', label: 'Satisfaction' }
    ],
    office: { title: 'Hyderabad Headquarters', address: 'VIP Hills, Silicon valley, Madhapur, Hyderabad - 500081, Telangana', hours: 'Monday - Friday: 9:00 AM - 7:00 PM, Saturday: 10:00 AM - 4:00 PM', availability: 'Meetings by appointment, Virtual consultations, 24/7 emergency', map_embed: 'https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d7612.584996745508!2d78.38633559192071!3d17.445708893577407!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sin!4v1774850334297!5m2!1sen!2sin' },
    team: { title: 'Your Royal Team', subtitle: 'Experienced professionals dedicated to making your celebrations extraordinary', members: [
      { name: 'Rajesh Singh', position: 'Royal Event Director', experience: '12+ Years Experience', expertise: ['Royal Heritage Festia', 'Grand Celebrations', 'Cultural Events'], image: '' },
      { name: 'Priya Reddy', position: 'Royal Dining Curator', experience: '10+ Years Experience', expertise: ['Royal Dinners', 'Culinary Excellence', 'VIP Hospitality'], image: '' },
      { name: 'Arjun Nair', position: 'Music & Concerts Director', experience: '15+ Years Experience', expertise: ['Live Concerts', 'Music Festivals', 'Artist Management'], image: '' },
      { name: 'Meera Kapoor', position: 'Guest Relations Head', experience: '8+ Years Experience', expertise: ['Guest Experience', 'Royal Protocol', 'VIP Services'], image: '' }
    ] },
    faq: { title: 'Frequently Asked Questions', subtitle: 'Quick answers about our royal services', items: [
      { question: "What is included in the Royal Heritage Festia experience?", answer: "Royal Heritage Festia includes curated heritage walks, royal processions, cultural performances, traditional cuisine, and immersive experiences." },
      { question: "How far in advance should I book a Royal Dinner?", answer: "We recommend booking Royal Dinners 3-6 months in advance." },
      { question: "Do you handle international artists for Music & Concerts?", answer: "Yes! We have partnerships with world-class international artists." }
    ] },
    cta: { title: 'Ready to Create Your Royal Experience?', subtitle: 'Call us now or visit our Hyderabad office for a personal consultation', button1_text: 'Call +91 99662 52374', button2_text: 'WhatsApp Us', phone: '+919966252374' }
  });

  // ========== SIDEBAR MENU ITEMS ==========
  const menuItems = [
    { id: 'home', label: 'Home Page', icon: faHome, type: 'page' },
    { id: 'services-page', label: 'Services Page', icon: faStar, type: 'page' },
    { id: 'about-page', label: 'About Us Page', icon: faInfoCircle, type: 'page' },
    { id: 'contact-page', label: 'Contact Us Page', icon: faPhone, type: 'page' },
    { id: 'all-images', label: 'All Images', icon: faImage, type: 'images' }
  ];

  // ========== FETCH FUNCTIONS ==========
  useEffect(() => {
    fetchHomeContent();
    fetchServicesContent();
    fetchAboutContent();
    fetchContactContent();
    fetchAllImages();
  }, []);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setSidebarOpen(false);
      } else {
        setSidebarOpen(true);
      }
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const fetchHomeContent = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${API_BASE_URL}/get-home-content.php`);
      console.log('Home CMS Response:', response.data);
      
      if (response.data.success && response.data.data) {
        const fetchedData = response.data.data;
        const images = response.data.images || {};
        
        setHomeContent(prev => ({
          ...prev,
          hero: { ...prev.hero, ...fetchedData.hero, backgroundImage: images.hero_background || prev.hero.backgroundImage },
          carousel: { ...prev.carousel, ...fetchedData.carousel, slides: fetchedData.carousel?.slides || prev.carousel.slides },
          floatingImages: { ...prev.floatingImages, ...fetchedData.floatingImages },
          featuredEvent: { ...prev.featuredEvent, ...fetchedData.featuredEvent, backgroundImage: images.featured_background || prev.featuredEvent.backgroundImage },
          upcomingEvents: { ...prev.upcomingEvents, ...fetchedData.upcomingEvents },
          services: { ...prev.services, ...fetchedData.services },
          booking: { ...prev.booking, ...fetchedData.booking },
          about: { ...prev.about, ...fetchedData.about, image: images.about_image || prev.about.image },
          testimonials: { ...prev.testimonials, ...fetchedData.testimonials },
          location: { ...prev.location, ...fetchedData.location },
          cta: { ...prev.cta, ...fetchedData.cta },
          seo: { ...prev.seo, ...fetchedData.seo, ogImage: images.og_image || prev.seo.ogImage },
          colors: { ...prev.colors, ...fetchedData.colors }
        }));
        
        // Update carousel slide images
        if (images.carousel_1 || images.carousel_2 || images.carousel_3) {
          setHomeContent(prev => ({
            ...prev,
            carousel: {
              ...prev.carousel,
              slides: prev.carousel.slides.map((slide, idx) => ({
                ...slide,
                image: images[`carousel_${idx + 1}`] || slide.image
              }))
            }
          }));
        }
        
        // Update floating images
        if (images.floating_image_1 || images.floating_image_2) {
          setHomeContent(prev => ({
            ...prev,
            floatingImages: {
              ...prev.floatingImages,
              images: prev.floatingImages.images.map((img, idx) => ({
                ...img,
                url: images[`floating_image_${idx + 1}`] || img.url
              }))
            }
          }));
        }
        
        // Update testimonial images
        if (images.testimonial_1_avatar || images.testimonial_2_avatar || images.testimonial_3_avatar) {
          setHomeContent(prev => ({
            ...prev,
            testimonials: {
              ...prev.testimonials,
              items: prev.testimonials.items.map((item, idx) => ({
                ...item,
                image: images[`testimonial_${idx + 1}_avatar`] || item.image
              }))
            }
          }));
        }
        
        // Update service images
        if (images.service1_image || images.service2_image || images.service3_image) {
          setHomeContent(prev => ({
            ...prev,
            services: {
              ...prev.services,
              items: prev.services.items.map((item, idx) => ({
                ...item,
                image: images[`service${idx + 1}_image`] || item.image
              }))
            }
          }));
        }
      }
    } catch (error) {
      console.error('Error fetching home content:', error);
      setErrorMessage('Failed to load home content');
    } finally {
      setLoading(false);
    }
  };

  const fetchServicesContent = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/get-services-content.php`);
      if (response.data.success && response.data.data) {
        const fetchedData = response.data.data;
        const images = response.data.images || {};
        
        setServicesContent(prev => ({
          ...prev,
          hero: { ...prev.hero, ...fetchedData.hero, backgroundImage: images.services_hero_background || prev.hero.backgroundImage },
          services_section: { ...prev.services_section, ...fetchedData.services_section },
          service1: { ...prev.service1, ...fetchedData.service1, image: images.service1_image || prev.service1.image },
          service2: { ...prev.service2, ...fetchedData.service2, image: images.service2_image || prev.service2.image },
          service3: { ...prev.service3, ...fetchedData.service3, image: images.service3_image || prev.service3.image },
          why_choose_us: { ...prev.why_choose_us, ...fetchedData.why_choose_us },
          why_items: Array.isArray(fetchedData.why_items) ? fetchedData.why_items : prev.why_items,
          supporting_services: { ...prev.supporting_services, ...fetchedData.supporting_services },
          support_items: Array.isArray(fetchedData.support_items) ? fetchedData.support_items : prev.support_items,
          our_process: { ...prev.our_process, ...fetchedData.our_process },
          process_items: Array.isArray(fetchedData.process_items) ? fetchedData.process_items : prev.process_items,
          testimonials: { ...prev.testimonials, ...fetchedData.testimonials },
          testimonial_items: Array.isArray(fetchedData.testimonial_items) ? fetchedData.testimonial_items : prev.testimonial_items,
          faq: { ...prev.faq, ...fetchedData.faq },
          faq_items: Array.isArray(fetchedData.faq_items) ? fetchedData.faq_items : prev.faq_items,
          booking: { ...prev.booking, ...fetchedData.booking }
        }));
      }
    } catch (error) {
      console.error('Error fetching services content:', error);
    }
  };

  const fetchAboutContent = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/get-about-content.php`);
      if (response.data.success && response.data.data) {
        const fetchedData = response.data.data;
        const images = response.data.images || {};
        
        setAboutContent(prev => ({
          ...prev,
          hero: { ...prev.hero, ...fetchedData.hero, backgroundImage: images.about_hero_background || prev.hero.backgroundImage },
          story: { ...prev.story, ...fetchedData.story, image: images.story_image || prev.story.image },
          mission: { ...prev.mission, ...fetchedData.mission },
          vision: { ...prev.vision, ...fetchedData.vision },
          values: { ...prev.values, ...fetchedData.values, items: Array.isArray(fetchedData.values?.items) ? fetchedData.values.items : prev.values.items },
          team: { ...prev.team, ...fetchedData.team, members: Array.isArray(fetchedData.team?.members) ? fetchedData.team.members : prev.team.members },
          cta: { ...prev.cta, ...fetchedData.cta }
        }));
      }
    } catch (error) {
      console.error('Error fetching about content:', error);
    }
  };
// ========== CORRECTED fetchContactContent - For CMS Dashboard ==========
const fetchContactContent = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/get-contact-content.php`);
    console.log('Contact CMS Response:', response.data);
    
    if (response.data.success && response.data.data) {
      const fetchedData = response.data.data;
      const images = response.data.images || {};
      
      setContactContent(prev => ({
        ...prev,
        hero: {
          ...prev.hero,
          ...fetchedData.hero,
          backgroundImage: images.contact_hero_background || prev.hero.backgroundImage
        },
        contact_cards: fetchedData.contact_cards && Array.isArray(fetchedData.contact_cards) 
          ? fetchedData.contact_cards 
          : prev.contact_cards,
        stats: fetchedData.stats && Array.isArray(fetchedData.stats) 
          ? fetchedData.stats 
          : prev.stats,
        office: { ...prev.office, ...fetchedData.office },
        team: {
          ...prev.team,
          ...fetchedData.team,
          members: fetchedData.team?.members && Array.isArray(fetchedData.team.members) 
            ? fetchedData.team.members 
            : prev.team.members
        },
        faq: {
          ...prev.faq,
          ...fetchedData.faq,
          items: fetchedData.faq?.items && Array.isArray(fetchedData.faq.items) 
            ? fetchedData.faq.items 
            : prev.faq.items
        },
        cta: { ...prev.cta, ...fetchedData.cta }
      }));
    }
  } catch (error) {
    console.error('Error fetching contact content:', error);
  }
};

  const fetchAllImages = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/cms-images.php`);
      if (response.data.success) {
        setAllImages(response.data.images);
      }
    } catch (error) {
      console.error('Error fetching images:', error);
    }
  };

  // ========== SAVE FUNCTIONS ==========
  const saveHomeContent = async () => {
    setSaving(true);
    setSuccessMessage('');
    setErrorMessage('');
    
    try {
      const imagesToSave = {};
      if (homeContent.hero.backgroundImage) imagesToSave.hero_background = homeContent.hero.backgroundImage;
      homeContent.carousel.slides.forEach((slide, idx) => { if (slide.image) imagesToSave[`carousel_${idx + 1}`] = slide.image; });
      homeContent.floatingImages.images.forEach((img, idx) => { if (img.url) imagesToSave[`floating_image_${idx + 1}`] = img.url; });
      if (homeContent.featuredEvent.backgroundImage) imagesToSave.featured_background = homeContent.featuredEvent.backgroundImage;
      if (homeContent.about.image) imagesToSave.about_image = homeContent.about.image;
      homeContent.testimonials.items.forEach((item, idx) => { if (item.image) imagesToSave[`testimonial_${idx + 1}_avatar`] = item.image; });
      homeContent.services.items.forEach((item, idx) => { if (item.image) imagesToSave[`service${idx + 1}_image`] = item.image; });
      if (homeContent.seo.ogImage) imagesToSave.og_image = homeContent.seo.ogImage;
      
      const response = await axios.post(`${API_BASE_URL}/save-home-content.php`, { data: homeContent, images: imagesToSave });
      if (response.data.success) {
        setSuccessMessage('Home page saved successfully!');
        setTimeout(() => setSuccessMessage(''), 3000);
      } else {
        setErrorMessage(response.data.error || 'Save failed');
      }
    } catch (error) {
      console.error('Save error:', error);
      setErrorMessage('Error saving content: ' + (error.response?.data?.error || error.message));
    } finally {
      setSaving(false);
    }
  };

  const saveServicesContent = async () => {
    setSaving(true);
    try {
      const imagesToSave = {};
      if (servicesContent.hero.backgroundImage) imagesToSave.services_hero_background = servicesContent.hero.backgroundImage;
      if (servicesContent.service1.image) imagesToSave.service1_image = servicesContent.service1.image;
      if (servicesContent.service2.image) imagesToSave.service2_image = servicesContent.service2.image;
      if (servicesContent.service3.image) imagesToSave.service3_image = servicesContent.service3.image;
      
      await axios.post(`${API_BASE_URL}/save-services-content.php`, { data: servicesContent, images: imagesToSave });
      setSuccessMessage('Services page saved successfully!');
      setTimeout(() => setSuccessMessage(''), 3000);
    } catch (error) {
      setErrorMessage('Error saving services content');
    } finally {
      setSaving(false);
    }
  };

  const saveAboutContent = async () => {
    setSaving(true);
    try {
      const imagesToSave = {};
      if (aboutContent.hero.backgroundImage) imagesToSave.about_hero_background = aboutContent.hero.backgroundImage;
      if (aboutContent.story.image) imagesToSave.story_image = aboutContent.story.image;
      
      await axios.post(`${API_BASE_URL}/save-about-content.php`, { data: aboutContent, images: imagesToSave });
      setSuccessMessage('About page saved successfully!');
      setTimeout(() => setSuccessMessage(''), 3000);
    } catch (error) {
      setErrorMessage('Error saving about content');
    } finally {
      setSaving(false);
    }
  };

  const saveContactContent = async () => {
    setSaving(true);
    try {
      const imagesToSave = {};
      if (contactContent.hero.backgroundImage) imagesToSave.contact_hero_background = contactContent.hero.backgroundImage;
      
      await axios.post(`${API_BASE_URL}/save-contact-content.php`, { data: contactContent, images: imagesToSave });
      setSuccessMessage('Contact page saved successfully!');
      setTimeout(() => setSuccessMessage(''), 3000);
    } catch (error) {
      setErrorMessage('Error saving contact content');
    } finally {
      setSaving(false);
    }
  };

  // ========== UNIVERSAL IMAGE UPLOAD FUNCTION ==========
  const uploadImage = async (file, imageKey, callback) => {
    if (!file) return;
    setUploadingImage(imageKey);
    const formData = new FormData();
    formData.append('image', file);
    formData.append('image_key', imageKey);
    formData.append('page', activePage);
    
    try {
      const response = await axios.post(`${API_BASE_URL}/cms-upload.php`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      
      if (response.data.success) {
        if (callback) callback(response.data.image_url);
        fetchAllImages();
        setSuccessMessage('Image uploaded successfully!');
        setTimeout(() => setSuccessMessage(''), 3000);
      } else {
        setErrorMessage(response.data.error || 'Upload failed');
      }
    } catch (error) {
      console.error('Upload error:', error);
      setErrorMessage('Error uploading image');
    } finally {
      setUploadingImage(null);
    }
  };

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
    setSuccessMessage('Copied to clipboard!');
    setTimeout(() => setSuccessMessage(''), 2000);
  };

  // ========== HOME EDITOR RENDER FUNCTIONS ==========
  const handleHomeHeroImageUpload = () => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*';
    input.onchange = (e) => {
      if (e.target.files[0]) {
        uploadImage(e.target.files[0], 'hero_background', (url) => {
          setHomeContent(prev => ({ ...prev, hero: { ...prev.hero, backgroundImage: url } }));
        });
      }
    };
    input.click();
  };

  const handleServiceItemImageUpload = (index) => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*';
    input.onchange = (e) => {
      if (e.target.files[0]) {
        uploadImage(e.target.files[0], `service${index + 1}_image`, (url) => {
          const newItems = [...homeContent.services.items];
          newItems[index] = { ...newItems[index], image: url };
          setHomeContent(prev => ({ ...prev, services: { ...prev.services, items: newItems } }));
        });
      }
    };
    input.click();
  };

  // ========== RENDER HOME EDITOR ==========
  const renderHomeEditor = () => {
    if (activeTab === 'content') {
      return (
        <div className="editor-content-scroll">
          <div className="quick-actions">
            <button className="quick-action-btn" onClick={saveHomeContent} disabled={saving}>
              <FontAwesomeIcon icon={faSave} /> Save All
            </button>
            <button className="quick-action-btn" onClick={() => window.open('/', '_blank')}>
              <FontAwesomeIcon icon={faEye} /> Preview Site
            </button>
            <button className="quick-action-btn" onClick={fetchHomeContent}>
              <FontAwesomeIcon icon={faSyncAlt} /> Refresh
            </button>
          </div>
          
          <div className="edit-card">
            <div className="card-header">
              <h3><FontAwesomeIcon icon={faHome} /> Hero Section</h3>
              <div className="card-toggle">
                <label className="switch">
                  <input type="checkbox" checked={homeContent.hero.enabled} onChange={(e) => setHomeContent(prev => ({ ...prev, hero: { ...prev.hero, enabled: e.target.checked } }))} />
                  <span className="slider"></span>
                </label>
              </div>
            </div>
            <div className="card-body">
              <div className="form-group"><label>Hero Title</label><input type="text" className="form-control" value={homeContent.hero.title} onChange={(e) => setHomeContent(prev => ({ ...prev, hero: { ...prev.hero, title: e.target.value } }))} /></div>
              <div className="form-group"><label>Hero Subtitle</label><input type="text" className="form-control" value={homeContent.hero.subtitle} onChange={(e) => setHomeContent(prev => ({ ...prev, hero: { ...prev.hero, subtitle: e.target.value } }))} /></div>
              <div className="form-group"><label>Hero Description</label><textarea className="form-control" rows="3" value={homeContent.hero.description} onChange={(e) => setHomeContent(prev => ({ ...prev, hero: { ...prev.hero, description: e.target.value } }))} /></div>
              <div className="form-row">
                <div className="form-group"><label>Button Text</label><input type="text" className="form-control" value={homeContent.hero.buttonText} onChange={(e) => setHomeContent(prev => ({ ...prev, hero: { ...prev.hero, buttonText: e.target.value } }))} /></div>
                <div className="form-group"><label>Phone Number</label><input type="text" className="form-control" value={homeContent.hero.phone} onChange={(e) => setHomeContent(prev => ({ ...prev, hero: { ...prev.hero, phone: e.target.value } }))} /></div>
              </div>
              <div className="form-group">
                <label>Hero Background Image</label>
                <div className="image-upload-area">
                  {homeContent.hero.backgroundImage ? (
                    <div className="image-preview"><img src={homeContent.hero.backgroundImage} alt="Hero Background" /><button className="btn-remove-image" onClick={() => setHomeContent(prev => ({ ...prev, hero: { ...prev.hero, backgroundImage: '' } }))}>×</button><button className="btn-copy-url" onClick={() => copyToClipboard(homeContent.hero.backgroundImage)}><FontAwesomeIcon icon={faCopy} /> Copy URL</button></div>
                  ) : (
                    <div className="image-placeholder" onClick={handleHomeHeroImageUpload}><FontAwesomeIcon icon={faUpload} /><span>Click to upload hero background image</span>{uploadingImage === 'hero_background' && <FontAwesomeIcon icon={faSpinner} spin className="upload-spinner" />}</div>
                  )}
                </div>
              </div>
            </div>
          </div>
          
          <div className="edit-card">
            <div className="card-header">
              <h3><FontAwesomeIcon icon={faImage} /> Carousel Slider</h3>
              <div className="card-toggle">
                <label className="switch">
                  <input type="checkbox" checked={homeContent.carousel.enabled} onChange={(e) => setHomeContent(prev => ({ ...prev, carousel: { ...prev.carousel, enabled: e.target.checked } }))} />
                  <span className="slider"></span>
                </label>
              </div>
            </div>
            <div className="card-body">
              <div className="form-row">
                <div className="form-group"><label>Auto Play</label><select className="form-control" value={homeContent.carousel.autoPlay} onChange={(e) => setHomeContent(prev => ({ ...prev, carousel: { ...prev.carousel, autoPlay: e.target.value === 'true' } }))}><option value="true">Yes</option><option value="false">No</option></select></div>
                <div className="form-group"><label>Slide Interval (ms)</label><input type="number" className="form-control" value={homeContent.carousel.interval} onChange={(e) => setHomeContent(prev => ({ ...prev, carousel: { ...prev.carousel, interval: parseInt(e.target.value) } }))} /></div>
              </div>
              
              {homeContent.carousel.slides.map((slide, idx) => (
                <div className="sub-card" key={slide.id}>
                  <div className="sub-card-header">
                    <h4>Slide {idx + 1}</h4>
                    {homeContent.carousel.slides.length > 1 && (<button className="btn-delete" onClick={() => { const newSlides = [...homeContent.carousel.slides]; newSlides.splice(idx, 1); setHomeContent(prev => ({ ...prev, carousel: { ...prev.carousel, slides: newSlides } })); }}><FontAwesomeIcon icon={faTrashAlt} /></button>)}
                  </div>
                  <div className="image-upload-area">
                    {slide.image ? (
                      <div className="image-preview"><img src={slide.image} alt={`Slide ${idx + 1}`} /><button className="btn-remove-image" onClick={() => { const newSlides = [...homeContent.carousel.slides]; newSlides[idx] = { ...newSlides[idx], image: '' }; setHomeContent(prev => ({ ...prev, carousel: { ...prev.carousel, slides: newSlides } })); }}>×</button><button className="btn-copy-url" onClick={() => copyToClipboard(slide.image)}><FontAwesomeIcon icon={faCopy} /> Copy URL</button></div>
                    ) : (
                      <div className="image-placeholder" onClick={() => { const input = document.createElement('input'); input.type = 'file'; input.accept = 'image/*'; input.onchange = (e) => { if (e.target.files[0]) { uploadImage(e.target.files[0], `carousel_${idx + 1}`, (url) => { const newSlides = [...homeContent.carousel.slides]; newSlides[idx] = { ...newSlides[idx], image: url }; setHomeContent(prev => ({ ...prev, carousel: { ...prev.carousel, slides: newSlides } })); }); } }; input.click(); }}><FontAwesomeIcon icon={faUpload} /><span>Click to upload image</span>{uploadingImage === `carousel_${idx + 1}` && <FontAwesomeIcon icon={faSpinner} spin className="upload-spinner" />}</div>
                    )}
                  </div>
                  <div className="form-group"><label>Slide Title</label><input type="text" className="form-control" value={slide.title} onChange={(e) => { const newSlides = [...homeContent.carousel.slides]; newSlides[idx] = { ...newSlides[idx], title: e.target.value }; setHomeContent(prev => ({ ...prev, carousel: { ...prev.carousel, slides: newSlides } })); }} /></div>
                  <div className="form-group"><label>Slide Description</label><textarea className="form-control" rows="2" value={slide.description} onChange={(e) => { const newSlides = [...homeContent.carousel.slides]; newSlides[idx] = { ...newSlides[idx], description: e.target.value }; setHomeContent(prev => ({ ...prev, carousel: { ...prev.carousel, slides: newSlides } })); }} /></div>
                  <div className="form-group"><label>Slide Link (URL)</label><input type="text" className="form-control" value={slide.link} onChange={(e) => { const newSlides = [...homeContent.carousel.slides]; newSlides[idx] = { ...newSlides[idx], link: e.target.value }; setHomeContent(prev => ({ ...prev, carousel: { ...prev.carousel, slides: newSlides } })); }} /></div>
                </div>
              ))}
              <button className="btn-add" onClick={() => { const newId = Math.max(...homeContent.carousel.slides.map(s => s.id), 0) + 1; setHomeContent(prev => ({ ...prev, carousel: { ...prev.carousel, slides: [...prev.carousel.slides, { id: newId, title: 'New Slide', description: 'Slide description', link: '/', image: '' }] } })); }}><FontAwesomeIcon icon={faPlus} /> Add Slide</button>
            </div>
          </div>
          
          <div className="edit-card">
            <div className="card-header"><h3><FontAwesomeIcon icon={faStore} /> Services Section</h3><div className="card-toggle"><label className="switch"><input type="checkbox" checked={homeContent.services.enabled} onChange={(e) => setHomeContent(prev => ({ ...prev, services: { ...prev.services, enabled: e.target.checked } }))} /><span className="slider"></span></label></div></div>
            <div className="card-body">
              <div className="form-group"><label>Section Title</label><input type="text" className="form-control" value={homeContent.services.title} onChange={(e) => setHomeContent(prev => ({ ...prev, services: { ...prev.services, title: e.target.value } }))} /></div>
              <div className="form-group"><label>Section Subtitle</label><input type="text" className="form-control" value={homeContent.services.subtitle} onChange={(e) => setHomeContent(prev => ({ ...prev, services: { ...prev.services, subtitle: e.target.value } }))} /></div>
              {homeContent.services.items.map((service, idx) => (
                <div className="sub-card" key={service.id}>
                  <div className="sub-card-header"><h4>Service {idx + 1}</h4>{homeContent.services.items.length > 1 && (<button className="btn-delete" onClick={() => { const newItems = [...homeContent.services.items]; newItems.splice(idx, 1); setHomeContent(prev => ({ ...prev, services: { ...prev.services, items: newItems } })); }}><FontAwesomeIcon icon={faTrashAlt} /></button>)}</div>
                  <div className="form-group"><label>Service Title</label><input type="text" className="form-control" value={service.title} onChange={(e) => { const newItems = [...homeContent.services.items]; newItems[idx] = { ...newItems[idx], title: e.target.value }; setHomeContent(prev => ({ ...prev, services: { ...prev.services, items: newItems } })); }} /></div>
                  <div className="form-group"><label>Service Description</label><textarea className="form-control" rows="2" value={service.description} onChange={(e) => { const newItems = [...homeContent.services.items]; newItems[idx] = { ...newItems[idx], description: e.target.value }; setHomeContent(prev => ({ ...prev, services: { ...prev.services, items: newItems } })); }} /></div>
                  <div className="form-group"><label>Service Link (URL)</label><input type="text" className="form-control" value={service.link} onChange={(e) => { const newItems = [...homeContent.services.items]; newItems[idx] = { ...newItems[idx], link: e.target.value }; setHomeContent(prev => ({ ...prev, services: { ...prev.services, items: newItems } })); }} /></div>
                  <div className="form-group">
                    <label>Service Image</label>
                    <div className="image-upload-area small">
                      {service.image ? (
                        <div className="image-preview small"><img src={service.image} alt={service.title} /><button className="btn-remove-image" onClick={() => { const newItems = [...homeContent.services.items]; newItems[idx] = { ...newItems[idx], image: '' }; setHomeContent(prev => ({ ...prev, services: { ...prev.services, items: newItems } })); }}>×</button></div>
                      ) : (
                        <div className="image-placeholder small" onClick={() => handleServiceItemImageUpload(idx)}><FontAwesomeIcon icon={faUpload} /><span>Upload Image</span></div>
                      )}
                    </div>
                  </div>
                </div>
              ))}
              <button className="btn-add" onClick={() => { const newId = Math.max(...homeContent.services.items.map(i => i.id), 0) + 1; setHomeContent(prev => ({ ...prev, services: { ...prev.services, items: [...prev.services.items, { id: newId, title: 'New Service', description: 'Service description', link: '/', icon: 'star', image: '' }] } })); }}><FontAwesomeIcon icon={faPlus} /> Add Service</button>
            </div>
          </div>
          
          <div className="edit-card">
            <div className="card-header"><h3><FontAwesomeIcon icon={faInfoCircle} /> About Section</h3><div className="card-toggle"><label className="switch"><input type="checkbox" checked={homeContent.about.enabled} onChange={(e) => setHomeContent(prev => ({ ...prev, about: { ...prev.about, enabled: e.target.checked } }))} /><span className="slider"></span></label></div></div>
            <div className="card-body">
              <div className="form-group"><label>About Title</label><input type="text" className="form-control" value={homeContent.about.title} onChange={(e) => setHomeContent(prev => ({ ...prev, about: { ...prev.about, title: e.target.value } }))} /></div>
              <div className="form-group"><label>About Description</label><textarea className="form-control" rows="6" value={homeContent.about.description} onChange={(e) => setHomeContent(prev => ({ ...prev, about: { ...prev.about, description: e.target.value } }))} /></div>
              <div className="form-group">
                <label>About Section Image</label>
                <div className="image-upload-area small">
                  {homeContent.about.image ? (
                    <div className="image-preview small"><img src={homeContent.about.image} alt="About" /><button className="btn-remove-image" onClick={() => setHomeContent(prev => ({ ...prev, about: { ...prev.about, image: '' } }))}>×</button></div>
                  ) : (
                    <div className="image-placeholder small" onClick={() => { const input = document.createElement('input'); input.type = 'file'; input.accept = 'image/*'; input.onchange = (e) => { if (e.target.files[0]) { uploadImage(e.target.files[0], 'about_image', (url) => { setHomeContent(prev => ({ ...prev, about: { ...prev.about, image: url } })); }); } }; input.click(); }}><FontAwesomeIcon icon={faUpload} /><span>Upload Image</span></div>
                  )}
                </div>
              </div>
            </div>
          </div>
          
          <div className="edit-card">
            <div className="card-header"><h3><FontAwesomeIcon icon={faWhatsapp} /> Booking Form Section</h3><div className="card-toggle"><label className="switch"><input type="checkbox" checked={homeContent.booking.enabled} onChange={(e) => setHomeContent(prev => ({ ...prev, booking: { ...prev.booking, enabled: e.target.checked } }))} /><span className="slider"></span></label></div></div>
            <div className="card-body">
              <div className="form-group"><label>Form Title</label><input type="text" className="form-control" value={homeContent.booking.title} onChange={(e) => setHomeContent(prev => ({ ...prev, booking: { ...prev.booking, title: e.target.value } }))} /></div>
              <div className="form-group"><label>Form Subtitle</label><input type="text" className="form-control" value={homeContent.booking.subtitle} onChange={(e) => setHomeContent(prev => ({ ...prev, booking: { ...prev.booking, subtitle: e.target.value } }))} /></div>
              <div className="form-group"><label>WhatsApp Number</label><input type="text" className="form-control" value={homeContent.booking.whatsapp_number} onChange={(e) => setHomeContent(prev => ({ ...prev, booking: { ...prev.booking, whatsapp_number: e.target.value } }))} /></div>
              <div className="form-group"><label>Submit Button Text</label><input type="text" className="form-control" value={homeContent.booking.button_text} onChange={(e) => setHomeContent(prev => ({ ...prev, booking: { ...prev.booking, button_text: e.target.value } }))} /></div>
            </div>
          </div>
          
          <div className="edit-card">
            <div className="card-header"><h3><FontAwesomeIcon icon={faCode} /> SEO Settings</h3></div>
            <div className="card-body">
              <div className="form-group"><label>Meta Title</label><input type="text" className="form-control" value={homeContent.seo.metaTitle} onChange={(e) => setHomeContent(prev => ({ ...prev, seo: { ...prev.seo, metaTitle: e.target.value } }))} /></div>
              <div className="form-group"><label>Meta Description</label><textarea className="form-control" rows="2" value={homeContent.seo.metaDescription} onChange={(e) => setHomeContent(prev => ({ ...prev, seo: { ...prev.seo, metaDescription: e.target.value } }))} /></div>
              <div className="form-group"><label>Meta Keywords</label><input type="text" className="form-control" value={homeContent.seo.metaKeywords} onChange={(e) => setHomeContent(prev => ({ ...prev, seo: { ...prev.seo, metaKeywords: e.target.value } }))} /></div>
            </div>
          </div>
          
          <div className="edit-card">
            <div className="card-header"><h3><FontAwesomeIcon icon={faPalette} /> Theme Colors</h3></div>
            <div className="card-body">
              <div className="form-row">
                <div className="form-group"><label>Primary Color</label><div className="color-input"><input type="color" className="color-picker" value={homeContent.colors.primary} onChange={(e) => setHomeContent(prev => ({ ...prev, colors: { ...prev.colors, primary: e.target.value } }))} /><input type="text" className="form-control" value={homeContent.colors.primary} onChange={(e) => setHomeContent(prev => ({ ...prev, colors: { ...prev.colors, primary: e.target.value } }))} /></div></div>
                <div className="form-group"><label>Secondary Color</label><div className="color-input"><input type="color" className="color-picker" value={homeContent.colors.secondary} onChange={(e) => setHomeContent(prev => ({ ...prev, colors: { ...prev.colors, secondary: e.target.value } }))} /><input type="text" className="form-control" value={homeContent.colors.secondary} onChange={(e) => setHomeContent(prev => ({ ...prev, colors: { ...prev.colors, secondary: e.target.value } }))} /></div></div>
              </div>
              <div className="form-row">
                <div className="form-group"><label>Background Color</label><div className="color-input"><input type="color" className="color-picker" value={homeContent.colors.background} onChange={(e) => setHomeContent(prev => ({ ...prev, colors: { ...prev.colors, background: e.target.value } }))} /><input type="text" className="form-control" value={homeContent.colors.background} onChange={(e) => setHomeContent(prev => ({ ...prev, colors: { ...prev.colors, background: e.target.value } }))} /></div></div>
                <div className="form-group"><label>Accent Color</label><div className="color-input"><input type="color" className="color-picker" value={homeContent.colors.accent} onChange={(e) => setHomeContent(prev => ({ ...prev, colors: { ...prev.colors, accent: e.target.value } }))} /><input type="text" className="form-control" value={homeContent.colors.accent} onChange={(e) => setHomeContent(prev => ({ ...prev, colors: { ...prev.colors, accent: e.target.value } }))} /></div></div>
              </div>
            </div>
          </div>
        </div>
      );
    } else if (activeTab === 'images') {
      return (
        <div className="editor-content-scroll">
          <div className="images-gallery">
            <div className="gallery-header">
              <h3>All Uploaded Images</h3>
              <button className="btn-upload-new" onClick={() => { const input = document.createElement('input'); input.type = 'file'; input.accept = 'image/*'; input.multiple = true; input.onchange = (e) => { Array.from(e.target.files).forEach((file, index) => { setTimeout(() => { uploadImage(file, `manual_${Date.now()}_${index}`, () => fetchAllImages()); }, index * 500); }); }; input.click(); }}><FontAwesomeIcon icon={faPlus} /> Upload Images</button>
            </div>
            {allImages.length === 0 ? (
              <div className="no-images"><FontAwesomeIcon icon={faImage} /><p>No images uploaded yet. Click "Upload Images" to get started.</p></div>
            ) : (
              <div className="images-grid">
                {allImages.map((img, idx) => (
                  <div className="image-card" key={idx}>
                    <img src={img.image_url} alt={img.image_name} />
                    <div className="image-info">
                      <span className="image-name" title={img.image_name}>{img.image_name?.substring(0, 20)}...</span>
                      <div className="image-actions">
                        <button className="btn-copy" onClick={() => copyToClipboard(img.image_url)}><FontAwesomeIcon icon={faCopy} /></button>
                        <button className="btn-delete-image" onClick={() => { if (window.confirm('Delete this image?')) { } }}><FontAwesomeIcon icon={faTrashAlt} /></button>
                      </div>
                    </div>
                    <div className="image-details"><small>Key: {img.image_key}</small></div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      );
    }
    return null;
  };

  // ========== SERVICES EDITOR ==========
  const renderServicesEditor = () => {
    const faqItems = Array.isArray(servicesContent.faq_items) ? servicesContent.faq_items : [];
    
    return (
      <div className="editor-content-scroll">
        <div className="quick-actions">
          <button className="quick-action-btn" onClick={saveServicesContent} disabled={saving}>
            <FontAwesomeIcon icon={faSave} /> Save Services Page
          </button>
        </div>
        
        <div className="edit-card">
          <div className="card-header"><h3>Hero Section</h3></div>
          <div className="card-body">
            <div className="form-group"><label>Hero Title</label><input type="text" className="form-control" value={servicesContent.hero.title} onChange={(e) => setServicesContent(prev => ({ ...prev, hero: { ...prev.hero, title: e.target.value } }))} /></div>
            <div className="form-group"><label>Hero Subtitle</label><input type="text" className="form-control" value={servicesContent.hero.subtitle} onChange={(e) => setServicesContent(prev => ({ ...prev, hero: { ...prev.hero, subtitle: e.target.value } }))} /></div>
            <div className="form-group"><label>Button Text</label><input type="text" className="form-control" value={servicesContent.hero.button_text} onChange={(e) => setServicesContent(prev => ({ ...prev, hero: { ...prev.hero, button_text: e.target.value } }))} /></div>
          </div>
        </div>
        
        <div className="edit-card">
          <div className="card-header"><h3>Service 1: Royal Heritage Festia</h3></div>
          <div className="card-body">
            <div className="form-group"><label>Title</label><input type="text" className="form-control" value={servicesContent.service1.title} onChange={(e) => setServicesContent(prev => ({ ...prev, service1: { ...prev.service1, title: e.target.value } }))} /></div>
            <div className="form-group"><label>Description</label><textarea className="form-control" rows="3" value={servicesContent.service1.description} onChange={(e) => setServicesContent(prev => ({ ...prev, service1: { ...prev.service1, description: e.target.value } }))} /></div>
            <div className="form-group"><label>Path</label><input type="text" className="form-control" value={servicesContent.service1.path} onChange={(e) => setServicesContent(prev => ({ ...prev, service1: { ...prev.service1, path: e.target.value } }))} /></div>
            <div className="form-group"><label>Features (comma separated)</label><input type="text" className="form-control" value={servicesContent.service1.features?.join(', ') || ''} onChange={(e) => setServicesContent(prev => ({ ...prev, service1: { ...prev.service1, features: e.target.value.split(',').map(s => s.trim()) } }))} /></div>
          </div>
        </div>
        
        <div className="edit-card">
          <div className="card-header"><h3>Service 2: Royal Dinners</h3></div>
          <div className="card-body">
            <div className="form-group"><label>Title</label><input type="text" className="form-control" value={servicesContent.service2.title} onChange={(e) => setServicesContent(prev => ({ ...prev, service2: { ...prev.service2, title: e.target.value } }))} /></div>
            <div className="form-group"><label>Description</label><textarea className="form-control" rows="3" value={servicesContent.service2.description} onChange={(e) => setServicesContent(prev => ({ ...prev, service2: { ...prev.service2, description: e.target.value } }))} /></div>
            <div className="form-group"><label>Path</label><input type="text" className="form-control" value={servicesContent.service2.path} onChange={(e) => setServicesContent(prev => ({ ...prev, service2: { ...prev.service2, path: e.target.value } }))} /></div>
            <div className="form-group"><label>Features (comma separated)</label><input type="text" className="form-control" value={servicesContent.service2.features?.join(', ') || ''} onChange={(e) => setServicesContent(prev => ({ ...prev, service2: { ...prev.service2, features: e.target.value.split(',').map(s => s.trim()) } }))} /></div>
          </div>
        </div>
        
        <div className="edit-card">
          <div className="card-header"><h3>Service 3: Music & Concerts</h3></div>
          <div className="card-body">
            <div className="form-group"><label>Title</label><input type="text" className="form-control" value={servicesContent.service3.title} onChange={(e) => setServicesContent(prev => ({ ...prev, service3: { ...prev.service3, title: e.target.value } }))} /></div>
            <div className="form-group"><label>Description</label><textarea className="form-control" rows="3" value={servicesContent.service3.description} onChange={(e) => setServicesContent(prev => ({ ...prev, service3: { ...prev.service3, description: e.target.value } }))} /></div>
            <div className="form-group"><label>Path</label><input type="text" className="form-control" value={servicesContent.service3.path} onChange={(e) => setServicesContent(prev => ({ ...prev, service3: { ...prev.service3, path: e.target.value } }))} /></div>
            <div className="form-group"><label>Features (comma separated)</label><input type="text" className="form-control" value={servicesContent.service3.features?.join(', ') || ''} onChange={(e) => setServicesContent(prev => ({ ...prev, service3: { ...prev.service3, features: e.target.value.split(',').map(s => s.trim()) } }))} /></div>
          </div>
        </div>
        
        <div className="edit-card">
          <div className="card-header"><h3>FAQ Section</h3></div>
          <div className="card-body">
            <div className="form-group"><label>Section Title</label><input type="text" className="form-control" value={servicesContent.faq.title} onChange={(e) => setServicesContent(prev => ({ ...prev, faq: { ...prev.faq, title: e.target.value } }))} /></div>
            <div className="form-group"><label>Section Subtitle</label><input type="text" className="form-control" value={servicesContent.faq.subtitle} onChange={(e) => setServicesContent(prev => ({ ...prev, faq: { ...prev.faq, subtitle: e.target.value } }))} /></div>
            {faqItems.map((item, idx) => (
              <div className="sub-card" key={idx}>
                <div className="sub-card-header"><h4>FAQ {idx + 1}</h4><button className="btn-delete" onClick={() => { const newItems = [...faqItems]; newItems.splice(idx, 1); setServicesContent(prev => ({ ...prev, faq_items: newItems })); }}><FontAwesomeIcon icon={faTrashAlt} /></button></div>
                <div className="form-group"><label>Question</label><input type="text" className="form-control" value={item.question} onChange={(e) => { const newItems = [...faqItems]; newItems[idx].question = e.target.value; setServicesContent(prev => ({ ...prev, faq_items: newItems })); }} /></div>
                <div className="form-group"><label>Answer</label><textarea className="form-control" rows="2" value={item.answer} onChange={(e) => { const newItems = [...faqItems]; newItems[idx].answer = e.target.value; setServicesContent(prev => ({ ...prev, faq_items: newItems })); }} /></div>
              </div>
            ))}
            <button className="btn-add" onClick={() => { setServicesContent(prev => ({ ...prev, faq_items: [...prev.faq_items, { question: 'New Question', answer: 'New Answer' }] })); }}><FontAwesomeIcon icon={faPlus} /> Add FAQ</button>
          </div>
        </div>
        
        <div className="edit-card">
          <div className="card-header"><h3>Booking Section</h3></div>
          <div className="card-body">
            <div className="form-group"><label>Form Title</label><input type="text" className="form-control" value={servicesContent.booking.title} onChange={(e) => setServicesContent(prev => ({ ...prev, booking: { ...prev.booking, title: e.target.value } }))} /></div>
            <div className="form-group"><label>Form Subtitle</label><input type="text" className="form-control" value={servicesContent.booking.subtitle} onChange={(e) => setServicesContent(prev => ({ ...prev, booking: { ...prev.booking, subtitle: e.target.value } }))} /></div>
            <div className="form-group"><label>WhatsApp Number</label><input type="text" className="form-control" value={servicesContent.booking.whatsapp_number} onChange={(e) => setServicesContent(prev => ({ ...prev, booking: { ...prev.booking, whatsapp_number: e.target.value } }))} /></div>
            <div className="form-group"><label>Button Text</label><input type="text" className="form-control" value={servicesContent.booking.button_text} onChange={(e) => setServicesContent(prev => ({ ...prev, booking: { ...prev.booking, button_text: e.target.value } }))} /></div>
          </div>
        </div>
      </div>
    );
  };

  // ========== ABOUT EDITOR ==========
  const renderAboutEditor = () => (
    <div className="editor-content-scroll">
      <div className="quick-actions">
        <button className="quick-action-btn" onClick={saveAboutContent} disabled={saving}>
          <FontAwesomeIcon icon={faSave} /> Save About Page
        </button>
      </div>
      
      <div className="edit-card">
        <div className="card-header"><h3>Hero Section</h3></div>
        <div className="card-body">
          <div className="form-group"><label>Hero Title</label><input type="text" className="form-control" value={aboutContent.hero.title} onChange={(e) => setAboutContent(prev => ({ ...prev, hero: { ...prev.hero, title: e.target.value } }))} /></div>
          <div className="form-group"><label>Hero Subtitle</label><input type="text" className="form-control" value={aboutContent.hero.subtitle} onChange={(e) => setAboutContent(prev => ({ ...prev, hero: { ...prev.hero, subtitle: e.target.value } }))} /></div>
          <div className="form-group"><label>Hero Badge</label><input type="text" className="form-control" value={aboutContent.hero.badge} onChange={(e) => setAboutContent(prev => ({ ...prev, hero: { ...prev.hero, badge: e.target.value } }))} /></div>
        </div>
      </div>
      
      <div className="edit-card">
        <div className="card-header"><h3>Story Section</h3></div>
        <div className="card-body">
          <div className="form-group"><label>Title</label><input type="text" className="form-control" value={aboutContent.story.title} onChange={(e) => setAboutContent(prev => ({ ...prev, story: { ...prev.story, title: e.target.value } }))} /></div>
          <div className="form-group"><label>Lead Text</label><input type="text" className="form-control" value={aboutContent.story.lead} onChange={(e) => setAboutContent(prev => ({ ...prev, story: { ...prev.story, lead: e.target.value } }))} /></div>
          <div className="form-group"><label>Description 1</label><textarea className="form-control" rows="2" value={aboutContent.story.description1} onChange={(e) => setAboutContent(prev => ({ ...prev, story: { ...prev.story, description1: e.target.value } }))} /></div>
          <div className="form-group"><label>Description 2</label><textarea className="form-control" rows="2" value={aboutContent.story.description2} onChange={(e) => setAboutContent(prev => ({ ...prev, story: { ...prev.story, description2: e.target.value } }))} /></div>
        </div>
      </div>
      
      <div className="edit-card">
        <div className="card-header"><h3>Mission & Vision</h3></div>
        <div className="card-body">
          <div className="form-group"><label>Mission Title</label><input type="text" className="form-control" value={aboutContent.mission.title} onChange={(e) => setAboutContent(prev => ({ ...prev, mission: { ...prev.mission, title: e.target.value } }))} /></div>
          <div className="form-group"><label>Mission Description</label><textarea className="form-control" rows="2" value={aboutContent.mission.description} onChange={(e) => setAboutContent(prev => ({ ...prev, mission: { ...prev.mission, description: e.target.value } }))} /></div>
          <div className="form-group"><label>Vision Title</label><input type="text" className="form-control" value={aboutContent.vision.title} onChange={(e) => setAboutContent(prev => ({ ...prev, vision: { ...prev.vision, title: e.target.value } }))} /></div>
          <div className="form-group"><label>Vision Description</label><textarea className="form-control" rows="2" value={aboutContent.vision.description} onChange={(e) => setAboutContent(prev => ({ ...prev, vision: { ...prev.vision, description: e.target.value } }))} /></div>
        </div>
      </div>
    </div>
  );

  // ========== CONTACT EDITOR ==========
  const renderContactEditor = () => {
    const contactCards = Array.isArray(contactContent.contact_cards) ? contactContent.contact_cards : [];
    const faqItems = Array.isArray(contactContent.faq?.items) ? contactContent.faq.items : [];
    
    return (
      <div className="editor-content-scroll">
        <div className="quick-actions">
          <button className="quick-action-btn" onClick={saveContactContent} disabled={saving}>
            <FontAwesomeIcon icon={faSave} /> Save Contact Page
          </button>
        </div>
        
        <div className="edit-card">
          <div className="card-header"><h3>Hero Section</h3></div>
          <div className="card-body">
            <div className="form-group"><label>Hero Title</label><input type="text" className="form-control" value={contactContent.hero.title} onChange={(e) => setContactContent(prev => ({ ...prev, hero: { ...prev.hero, title: e.target.value } }))} /></div>
            <div className="form-group"><label>Hero Subtitle</label><input type="text" className="form-control" value={contactContent.hero.subtitle} onChange={(e) => setContactContent(prev => ({ ...prev, hero: { ...prev.hero, subtitle: e.target.value } }))} /></div>
            <div className="form-group"><label>Hero Badge</label><input type="text" className="form-control" value={contactContent.hero.badge} onChange={(e) => setContactContent(prev => ({ ...prev, hero: { ...prev.hero, badge: e.target.value } }))} /></div>
          </div>
        </div>
        
        <div className="edit-card">
          <div className="card-header"><h3>Contact Cards</h3></div>
          <div className="card-body">
            {contactCards.map((card, idx) => (
              <div className="sub-card" key={idx}>
                <div className="sub-card-header"><h4>{card.title}</h4><button className="btn-delete" onClick={() => { const newCards = [...contactCards]; newCards.splice(idx, 1); setContactContent(prev => ({ ...prev, contact_cards: newCards })); }}><FontAwesomeIcon icon={faTrashAlt} /></button></div>
                <div className="form-group"><label>Title</label><input type="text" className="form-control" value={card.title} onChange={(e) => { const newCards = [...contactCards]; newCards[idx].title = e.target.value; setContactContent(prev => ({ ...prev, contact_cards: newCards })); }} /></div>
                <div className="form-group"><label>Contact Info</label><input type="text" className="form-control" value={card.contact} onChange={(e) => { const newCards = [...contactCards]; newCards[idx].contact = e.target.value; setContactContent(prev => ({ ...prev, contact_cards: newCards })); }} /></div>
                <div className="form-group"><label>Subtitle</label><input type="text" className="form-control" value={card.subtitle} onChange={(e) => { const newCards = [...contactCards]; newCards[idx].subtitle = e.target.value; setContactContent(prev => ({ ...prev, contact_cards: newCards })); }} /></div>
                <div className="form-group"><label>Action Text</label><input type="text" className="form-control" value={card.action} onChange={(e) => { const newCards = [...contactCards]; newCards[idx].action = e.target.value; setContactContent(prev => ({ ...prev, contact_cards: newCards })); }} /></div>
              </div>
            ))}
            <button className="btn-add" onClick={() => { setContactContent(prev => ({ ...prev, contact_cards: [...prev.contact_cards, { icon: 'bi-telephone-fill', title: 'New Contact', subtitle: 'New Subtitle', contact: '', link_type: 'tel', action: 'Contact Now' }] })); }}><FontAwesomeIcon icon={faPlus} /> Add Contact Card</button>
          </div>
        </div>
        
        <div className="edit-card">
          <div className="card-header"><h3>Office Information</h3></div>
          <div className="card-body">
            <div className="form-group"><label>Office Title</label><input type="text" className="form-control" value={contactContent.office.title} onChange={(e) => setContactContent(prev => ({ ...prev, office: { ...prev.office, title: e.target.value } }))} /></div>
            <div className="form-group"><label>Address</label><textarea className="form-control" rows="2" value={contactContent.office.address} onChange={(e) => setContactContent(prev => ({ ...prev, office: { ...prev.office, address: e.target.value } }))} /></div>
            <div className="form-group"><label>Hours</label><input type="text" className="form-control" value={contactContent.office.hours} onChange={(e) => setContactContent(prev => ({ ...prev, office: { ...prev.office, hours: e.target.value } }))} /></div>
            <div className="form-group"><label>Map Embed Code</label><textarea className="form-control" rows="3" value={contactContent.office.map_embed} onChange={(e) => setContactContent(prev => ({ ...prev, office: { ...prev.office, map_embed: e.target.value } }))} /></div>
          </div>
        </div>
        
        <div className="edit-card">
          <div className="card-header"><h3>FAQ Section</h3></div>
          <div className="card-body">
            <div className="form-group"><label>Section Title</label><input type="text" className="form-control" value={contactContent.faq.title} onChange={(e) => setContactContent(prev => ({ ...prev, faq: { ...prev.faq, title: e.target.value } }))} /></div>
            <div className="form-group"><label>Section Subtitle</label><input type="text" className="form-control" value={contactContent.faq.subtitle} onChange={(e) => setContactContent(prev => ({ ...prev, faq: { ...prev.faq, subtitle: e.target.value } }))} /></div>
            {faqItems.map((item, idx) => (
              <div className="sub-card" key={idx}>
                <div className="sub-card-header"><h4>FAQ {idx + 1}</h4><button className="btn-delete" onClick={() => { const newItems = [...faqItems]; newItems.splice(idx, 1); setContactContent(prev => ({ ...prev, faq: { ...prev.faq, items: newItems } })); }}><FontAwesomeIcon icon={faTrashAlt} /></button></div>
                <div className="form-group"><label>Question</label><input type="text" className="form-control" value={item.question} onChange={(e) => { const newItems = [...faqItems]; newItems[idx].question = e.target.value; setContactContent(prev => ({ ...prev, faq: { ...prev.faq, items: newItems } })); }} /></div>
                <div className="form-group"><label>Answer</label><textarea className="form-control" rows="2" value={item.answer} onChange={(e) => { const newItems = [...faqItems]; newItems[idx].answer = e.target.value; setContactContent(prev => ({ ...prev, faq: { ...prev.faq, items: newItems } })); }} /></div>
              </div>
            ))}
            <button className="btn-add" onClick={() => { setContactContent(prev => ({ ...prev, faq: { ...prev.faq, items: [...prev.faq.items, { question: 'New Question', answer: 'New Answer' }] } })); }}><FontAwesomeIcon icon={faPlus} /> Add FAQ</button>
          </div>
        </div>
        
        <div className="edit-card">
          <div className="card-header"><h3>CTA Section</h3></div>
          <div className="card-body">
            <div className="form-group"><label>CTA Title</label><input type="text" className="form-control" value={contactContent.cta.title} onChange={(e) => setContactContent(prev => ({ ...prev, cta: { ...prev.cta, title: e.target.value } }))} /></div>
            <div className="form-group"><label>CTA Subtitle</label><input type="text" className="form-control" value={contactContent.cta.subtitle} onChange={(e) => setContactContent(prev => ({ ...prev, cta: { ...prev.cta, subtitle: e.target.value } }))} /></div>
            <div className="form-row">
              <div className="form-group"><label>Button 1 Text</label><input type="text" className="form-control" value={contactContent.cta.button1_text} onChange={(e) => setContactContent(prev => ({ ...prev, cta: { ...prev.cta, button1_text: e.target.value } }))} /></div>
              <div className="form-group"><label>Button 2 Text</label><input type="text" className="form-control" value={contactContent.cta.button2_text} onChange={(e) => setContactContent(prev => ({ ...prev, cta: { ...prev.cta, button2_text: e.target.value } }))} /></div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  // ========== RENDER FUNCTION ==========
  return (
    <div className="cms-dashboard">
      {mobileMenuOpen && <div className="mobile-overlay" onClick={() => setMobileMenuOpen(false)}></div>}
      <button className="sidebar-toggle" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}><FontAwesomeIcon icon={faBars} /></button>
      <button className="sidebar-toggle-desktop" onClick={() => setSidebarOpen(!sidebarOpen)}><FontAwesomeIcon icon={faBars} /></button>
      
      <div className={`cms-sidebar ${sidebarOpen ? 'open' : 'closed'} ${mobileMenuOpen ? 'mobile-open' : ''}`}>
        <div className="sidebar-header">
          <h2><FontAwesomeIcon icon={faCog} /> CMS Admin</h2>
          <button className="sidebar-close" onClick={() => setMobileMenuOpen(false)}><FontAwesomeIcon icon={faTimes} /></button>
        </div>
        <nav className="sidebar-nav">
          {menuItems.map(item => (
            <div key={item.id} className={`nav-item ${activePage === item.id ? 'active' : ''}`} onClick={() => { setActivePage(item.id); setMobileMenuOpen(false); setActiveTab('content'); }}>
              <FontAwesomeIcon icon={item.icon} />
              <span>{item.label}</span>
            </div>
          ))}
        </nav>
        <div className="sidebar-footer"><div className="version">Version 1.0.0</div></div>
      </div>
      
      <div className={`cms-main ${sidebarOpen ? 'sidebar-open' : 'sidebar-closed'}`}>
        <div className="cms-topbar">
          <div className="page-title">
            <h1>{menuItems.find(item => item.id === activePage)?.label || 'Dashboard'}</h1>
          </div>
          <div className="topbar-actions">
            {activePage !== 'all-images' && (
              <>
                <button className={`tab-switch ${activeTab === 'content' ? 'active' : ''}`} onClick={() => setActiveTab('content')}>
                  <FontAwesomeIcon icon={faFileAlt} /> Content
                </button>
                <button className={`tab-switch ${activeTab === 'images' ? 'active' : ''}`} onClick={() => setActiveTab('images')}>
                  <FontAwesomeIcon icon={faImage} /> Images
                </button>
              </>
            )}
          </div>
        </div>
        <div className="cms-content">
          {loading ? (
            <div className="loading-container"><FontAwesomeIcon icon={faSpinner} spin /><p>Loading...</p></div>
          ) : (
            <>
              {activePage === 'home' && renderHomeEditor()}
              {activePage === 'services-page' && renderServicesEditor()}
              {activePage === 'about-page' && renderAboutEditor()}
              {activePage === 'contact-page' && renderContactEditor()}
              {activePage === 'all-images' && renderHomeEditor()}
            </>
          )}
        </div>
      </div>
      
      {successMessage && (<div className="toast-message success"><FontAwesomeIcon icon={faCheckCircle} /> {successMessage}</div>)}
      {errorMessage && (<div className="toast-message error"><FontAwesomeIcon icon={faExclamationTriangle} /> {errorMessage}</div>)}
    </div>
  );
};

export default WebPageEditor;